export var ChargeDeliveryFeeFrom;
(function (ChargeDeliveryFeeFrom) {
    ChargeDeliveryFeeFrom["delivery_area_fee"] = "delivery_area_fee";
    ChargeDeliveryFeeFrom["shipping_option_fee"] = "shipping_option_fee";
})(ChargeDeliveryFeeFrom || (ChargeDeliveryFeeFrom = {}));
